module.exports = __webpack_public_path__ + "static/img/Beacon.9a5f0fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Beacon.jpg
// module id = kyfF
// module chunks = 1